import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActionType, AppDispatch, RootState } from "../../../reducer";
import { AddSubscriptionsAction, ClearSubscriptionMapAction, IncrementSubscriptionRefreshAction } from "../../../reducer/subscription";
import { Subscription } from "../../../types/subscription";
import { getSubscription } from "../../../api/subscription";
import { startSubscription, stopSubscription } from "../../../api/subscriptionControl";

export const useAddSubscriptions = () => {
  const dispatch = useDispatch<AppDispatch>();
  return (subscriptions: Subscription[]) => {
    const action: AddSubscriptionsAction = {
      type: ActionType.ADD_SUBSCRIPTIONS,
      subscriptions,
    };
    dispatch(action as any);
  };
};

export const useSubscription = (subId: string | undefined) => {
  return useSelector((state: RootState) => {
    if (!subId) return undefined;
    return state.ui.subscriptionMap?.[subId];
  });
};

export const useClearSubscriptionMap = () => {
  const dispatch = useDispatch<AppDispatch>();
  return () => {
    const action: ClearSubscriptionMapAction = {
      type: ActionType.CLEAR_SUBSCRIPTION_MAP,
    };
    dispatch(action as any);
  };
};

export const useIncrementSubscriptionRefresh = () => {
  const dispatch = useDispatch<AppDispatch>();
  return () => {
    const action: IncrementSubscriptionRefreshAction = {
      type: ActionType.INCREMENT_SUBSCRIPTION_REFRESH,
    };
    dispatch(action as any);
  };
};

export const useFetchSubscriptionListener = (subId: string) => {
  const addSubscriptions = useAddSubscriptions();
  const refreshKey = useSelector((state: RootState) => state.ui.subscriptionRefreshKey ?? 0);
  useEffect(() => {
    getSubscription({ "sub-id": subId }).then((sub) => {
      addSubscriptions([sub]);
    });
  }, [subId, refreshKey]);
};

export const useStartSubscription = (block: { "page-id": string; "app-id": string; "sub-id": string }) => {
  const addSubscriptions = useAddSubscriptions();
  return async () => {
    const result = await startSubscription({ "page-id": block["page-id"], "app-id": block["app-id"] });
    addSubscriptions([result]);
  };
};

export const useStopSubscription = (block: { "page-id": string; "app-id": string; "sub-id": string }) => {
  const addSubscriptions = useAddSubscriptions();
  return async () => {
    const result = await stopSubscription({ "page-id": block["page-id"], "app-id": block["app-id"] });
    addSubscriptions([result]);
  };
};
